import PersonProfileDao from '../dao/person-profile.dao';
import type { Environment } from '../interfaces/environment';

export abstract class PersonProfileService {
  static async getProfileById(env: Environment, personId?: number) {
    return !personId
      ? Promise.reject(new Error('Invalid id'))
      : await PersonProfileDao.getProfileById(env, personId);
  }

  static async getLiteProfileById(env: Environment, personId?: number) {
    return !personId
      ? Promise.reject(new Error('Invalid id'))
      : await PersonProfileDao.getLiteProfileById(env, personId);
  }

  static async getLiteProfileTeacherById(env: Environment, personId?: number) {
    return !personId
      ? Promise.reject(new Error('Invalid id'))
      : await PersonProfileDao.getLiteProfileTeacherById(env, personId);
  }
}
